import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";

import Select from 'react-select';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import Images from '../../utilies/Images';
import VehicleRotationModal from "../../component/advertModals/VehicleRotationModal";
import VehicleRotationDamagePhotoModal from "../../component/advertModals/VehicleRotationDamagePhotoModal";
import VehicleDamagePhotoNameModal from "../../component/advertModals/VehicleDamagePhotoNameModal";
import { isoToDate, isoToDateTime, priceFormat } from "../../inc/helper";
import TramerModal from "../../component/auctiom/TramerModal";

class AuctionVehicleEditModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      uploadLoading: false,
      isOpenRotationVehicleModal: false,
      isOpenRotationVehicleDamageFotoModal: false,
      isOpenVehicleDamageFotoNameModal: false,
      
      vehicleBrands: [],
      vehicleModels: [],
      vehicleModelYears: [],
      vehicleEquipments: [],

      vehicleBrandId: 0,
      vehicleModelId: 0,
      vehicleEquipmentId: 0,

			auctionVehicle: {},
      auctionVehiclePhotos: [],
      auctionVehicleDamagePhotos: [],
      auctionVehicleDamageHistory: [],
      vehicleEquipmentInfo: {},

      transmissions: [{type: 'Manuel'}, {type: 'Yarı Otomatik'}, {type: 'Otomatik'}],
      tractions: [{type: 'Önden Çekiş'}, {type: 'Arkadan İtiş'}, {type: '4X4'}],
      colors: [
        { id: 1, name: 'Altın' },
        { id: 2, name: 'Beyaz' },
        { id: 3, name: 'Bej' },
        { id: 4, name: 'Bordo' },
        { id: 5, name: 'Füme' },
        { id: 6, name: 'Gri' },
        { id: 7, name: 'Gümüş' },
        { id: 8, name: 'İnci Beyazı' },
        { id: 9, name: 'Kahverengi' },
        { id: 10, name: 'Kırmızı' },
        { id: 11, name: 'Lacivert' },
        { id: 12, name: 'Mavi' },
        { id: 13, name: 'Mor' },
        { id: 14, name: 'Sarı' },
        { id: 15, name: 'Siyah' },
        { id: 16, name: 'Şampanya' },
        { id: 17, name: 'Turuncu' },
        { id: 18, name: 'Turkuaz' },
        { id: 19, name: 'Yeşil' }
      ],
      registrationTypes: [
        { id: 1, name: 'Otomobil' },
        { id: 2, name: 'Arazi, SUV & Pickup' },
        { id: 3, name: 'Minivan & Panelvan' },
        { id: 4, name: 'Elektrikli' },
        { id: 5, name: 'Minibüs & Midibüs' },
        { id: 6, name: 'Otobüs' },
        { id: 7, name: 'Kamyon & Kamyonet' },
        { id: 8, name: 'Çekici' },
        { id: 9, name: 'Oto Kurtarıcı & Taşıyıcı' },
        { id: 10, name: 'Motosiklet' },
        { id: 11, name: 'ATV' },
        { id: 12, name: 'UTV' },
        { id: 13, name: 'Karavan' },
      ],
      damageName: '',
      fuelTypes: [{type: 'Benzin'}, {type: 'Dizel'}, {type: 'Benzin & LPG'}, {type: 'Elektrik'}, {type: 'Hibrit'}, {type: 'Elektrik & Hibrit'}, {type: 'Benzin & Hibrit'}],
      partsStatus: [{id: 'original', name: 'Orijinal'}, {id: 'replaced', name: 'Değişmiş'}, {id: 'painted', name: 'Boyalı'}, {id: 'localPainted', name: 'Lokal Boyalı'}, {id: 'plastic', name: 'Plastik Aksan'}]
    };
    this.scrollRef = React.createRef();
    this.scrollRefDamageFile = React.createRef();
    this.inputRef = React.createRef();
  }

  componentDidMount() {
		this.getAuctionVehicleInfo();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

	async getAuctionVehicleInfo() {
  let sessionHash = getCookie('sessionHash');
  this.setState({ isLoading: true });

  const requestOptions = {
    method: 'GET',
    headers: { 'Authorization': 'Bearer ' + sessionHash }
  };

  let errorMessages = [];

  try {
    // Araç bilgisi
    const res = await fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions);
    const responseData = await res.json();

    if (responseData.status !== 200) {
      throw new Error(responseData.message);
    }

    const auctionVehicle = responseData.auctionVehicleInfo;
    this.setState({
      auctionVehicle,
      auctionVehiclePhotos: auctionVehicle.photos,
      auctionVehicleDamagePhotos: auctionVehicle.damagePhotos,
      auctionVehicleDamageHistory: auctionVehicle.damageHistory
    });

    // Marka listesi
    const brandRes = await fetch(config.restApi + 'vehicleBrands/tr?limit=1000', requestOptions);
    const brandData = await brandRes.json();
    if (brandData.status === 200) {
      this.setState({ vehicleBrands: brandData.vehicleBrands });
    } else {
      errorMessages.push(brandData.message);
    }

    // Model listesi
    const modelRes = await fetch(config.restApi + 'vehicleModels/tr/' + auctionVehicle.vehicleBrandId + '?limit=1000', requestOptions);
    const modelData = await modelRes.json();
    if (modelData.status === 200) {
      this.setState({ vehicleModels: modelData.vehicleModels });
    } else {
      errorMessages.push(modelData.message);
    }

    // Model year listesi
    const yearRes = await fetch(config.restApi + 'vehicleModelYears/tr/' + auctionVehicle.vehicleModelId + '?limit=1000', requestOptions);
    const yearData = await yearRes.json();
    if (yearData.status === 200) {
      this.setState({ vehicleModelYears: yearData.vehicleModelYears });
    } else {
      errorMessages.push(yearData.message);
    }

    // Variant listesi
    const variantRes = await fetch(config.restApi + 'vehicleEquipments/tr/' + auctionVehicle.vehicleModelId + '/' + auctionVehicle.year + '?limit=1000', requestOptions);
    const variantData = await variantRes.json();
    if (variantData.status === 200) {
      this.setState({ vehicleEquipments: variantData.vehicleEquipments });
    } else {
      errorMessages.push(variantData.message);
    }

    // Equipment detayları (opsiyonel)
    if (auctionVehicle.vehicleEquipmentId) {
      const detailRes = await fetch(config.restApi + 'vehicleEquipmentDetails/tr/' + auctionVehicle.vehicleEquipmentId + '?limit=1000', requestOptions);
      const detailData = await detailRes.json();
      if (detailData.status === 200) {
        this.setState({ vehicleEquipmentInfo: detailData.vehicleEquipmentInfo });
      } else {
        errorMessages.push(detailData.message);
      }
    }

    // Tüm işlemler tamamlandı
    this.setState({ isLoading: false });

    if (errorMessages.length > 0) {
      swal({
        dangerMode: true,
        icon: 'warning',
        title: 'Hay Aksi',
        text: errorMessages[0],
        buttons: 'Tamam'
      }).then(() => this.props.navigate('/home'));
    }

  } catch (err) {
    this.setState({ isLoading: false });
    swal({
      dangerMode: true,
      icon: 'warning',
      title: 'Hay Aksi',
      text: err.message || 'Lütfen internet bağlantınızı kontrol ediniz.',
      buttons: 'Tamam'
    }).then(() => this.props.navigate('/home'));
  }

  window.scrollTo(0, 0);
}


	getModels(vehicleBrandId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleModels/tr/' + vehicleBrandId + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
					this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleBrandId: vehicleBrandId, vehicleModelId: '' }, vehicleModels: responseData.vehicleModels}));
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getYears(vehicleModelId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleModelYears/tr/' + vehicleModelId + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleModelId: vehicleModelId }, vehicleModelYears: responseData.vehicleModelYears}));
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getVariants(vehicleModelId, year) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleEquipments/tr/' + vehicleModelId + '/' + year + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
					this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleModelId: vehicleModelId, year: year }, vehicleEquipments: responseData.vehicleEquipments}));
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getAuctionVehicleInfoForFile() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
					this.setState({auctionVehiclePhotos: responseData.auctionVehicleInfo.photos});
          if (this.scrollRef.current) {
            this.scrollRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  getAuctionVehicleInfoForDamageFile() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
					this.setState({auctionVehicleDamagePhotos: responseData.auctionVehicleInfo.damagePhotos});
          if (this.scrollRefDamageFile.current) {
            this.scrollRefDamageFile.current.scrollIntoView({ behavior: 'smooth' });
          }
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  saveFileUpload = (index = 0) => {
    let sessionHash = getCookie('sessionHash');
    const formData = new FormData();
  
    for (let i = 0; i < this.state.files.length; i++) {
      formData.append('files', this.state.files[i]);
    }
  
    const fileCount = formData.getAll('files').length;
    const singleFileData = new FormData();
    singleFileData.append('files', formData.getAll('files')[index]);
  
    const requestOptions = {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + sessionHash },
      body: singleFileData,
    };
  
    this.setState({ uploadLoading: true });
  
    fetch(config.restApi + 'auctionVehiclePhotoUpload/tr/' + this.props.searchParams.get('id'), requestOptions)
      .then(response => response.json())
      .then(responseData => {
        const progressPercentage = ((index + 1) / fileCount) * 100;
        document.querySelector('.progress-bar').style.width = `${progressPercentage}%`;
        document.querySelector('.progress-bar').innerText = `%${Math.round(progressPercentage)} Tamamlandı`;
  
        switch (responseData.status) {
          case 200:
            if (index === fileCount - 1) {
              swal({
                dangerMode: true,
                icon: 'success',
                title: 'Başarılı',
                text: 'Tüm fotoğraflar ihaleye başarıyla eklendi.',
                buttons: 'Tamam'
              }).then(() => {this.setState({ isLoading: true }, () => { this.getAuctionVehicleInfoForFile(); this.setState({ files: '' }); this.setState({ isLoading: false, uploadLoading: false });});});
            } else {
              this.saveFileUpload(index + 1);
            }
            break;
          case 203:
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              }).then(() => this.setState({isLoading: true}, () => {this.getAuctionVehicleInfoForFile(); this.setState({files: ''});this.setState({isLoading: false, uploadLoading:false});}));
              break;
          case 401:
            swal({
              dangerMode: true,
              icon: 'warning',
              title: 'Hay Aksi',
              text: responseData.message,
              buttons: 'Tamam'
            }).then(this.getAuctionVehicleInfoForFile(), this.setState({uploadLoading: false}));
          break;
          default:
            swal({
              dangerMode: true,
              icon: 'warning',
              title: 'Hay Aksi',
              text: responseData.message,
              buttons: 'Tamam'
            }).then(() => {
              this.getAuctionVehicleInfoForFile();
              this.setState({ uploadLoading: false });
            });
            break;
        }
      })
      .catch(() => {
          swal({
            dangerMode: true,
            icon: 'error',
            title: 'Bağlantı Hatası',
            text: 'Lütfen internet bağlantınızı kontrol ediniz.',
            buttons: 'Tamam',
          }).then(() => this.setState({ uploadLoading: false }));
      });
  };

  saveDamageFileUpload = (index = 0) => {
    let sessionHash = getCookie('sessionHash');
    const formData = new FormData();
  
    for (let i = 0; i < this.state.damageFiles.length; i++) {
      formData.append('files', this.state.damageFiles[i]);
    }
  
    const fileCount = formData.getAll('files').length;
    const singleFileData = new FormData();
    singleFileData.append('files', formData.getAll('files')[index]);
  
    const requestOptions = {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + sessionHash },
      body: singleFileData,
    };
  
    this.setState({ uploadLoading: true });
  
    fetch(config.restApi + 'auctionVehicleDamagePhotoUpload/tr/' + this.props.searchParams.get('id'), requestOptions)
      .then(response => response.json())
      .then(responseData => {
        const progressPercentage = ((index + 1) / fileCount) * 100;
        document.querySelector('.progress-bar').style.width = `${progressPercentage}%`;
        document.querySelector('.progress-bar').innerText = `%${Math.round(progressPercentage)} Tamamlandı`;
  
        switch (responseData.status) {
          case 200:
            if (index === fileCount - 1) {
              swal({
                dangerMode: true,
                icon: 'success',
                title: 'Başarılı',
                text: 'Tüm fotoğraflar ihaleye başarıyla eklendi.',
                buttons: 'Tamam'
              }).then(() => {this.setState({ isLoading: true }, () => { this.getAuctionVehicleInfoForDamageFile(); this.setState({ damageFiles: '' }); this.setState({ isLoading: false, uploadLoading: false });});});
            } else {
              this.saveFileUpload(index + 1);
            }
            break;
          case 203:
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              }).then(() => this.setState({isLoading: true}, () => {this.getAuctionVehicleInfoForDamageFile(); this.setState({damageFiles: ''});this.setState({isLoading: false, uploadLoading:false});}));
              break;
          case 401:
            swal({
              dangerMode: true,
              icon: 'warning',
              title: 'Hay Aksi',
              text: responseData.message,
              buttons: 'Tamam'
            }).then(this.getAuctionVehicleInfoForDamageFile(), this.setState({uploadLoading: false}));
          break;
          default:
            swal({
              dangerMode: true,
              icon: 'warning',
              title: 'Hay Aksi',
              text: responseData.message,
              buttons: 'Tamam'
            }).then(() => {
              this.getAuctionVehicleInfoForDamageFile();
              this.setState({ uploadLoading: false });
            });
            break;
        }
      })
      .catch(() => {
          swal({
            dangerMode: true,
            icon: 'error',
            title: 'Bağlantı Hatası',
            text: 'Lütfen internet bağlantınızı kontrol ediniz.',
            buttons: 'Tamam',
          }).then(() => this.setState({ uploadLoading: false }));
      });
  };

  deleteVahiclePhotoOnClick(uploadId) {
    this.setState({isLoading: true});
    swal({
      dangerMode: true,
      icon: 'warning',
      title: 'Onayla',
      text: 'İlan resmini silmek istediğinize emin misiniz?',
      buttons: {confirm: 'Tamam', cancel: 'Vazgeç'}
    }).then(value => {
      if (value) {
        let sessionHash = getCookie('sessionHash');

        const requestOptions = {
          method: 'DELETE',
          headers: {'Authorization': 'Bearer ' + sessionHash},
        };

        fetch(config.restApi + 'auctionVehiclePhotoUpload/tr/' + uploadId, requestOptions)
        .then(response => response.json())
        .then(responseData => {
          switch (responseData.status) {
            case 200: {
              swal({
                dangerMode: true,
                icon: 'success',
                title: 'Tamamlandı',
                text: 'İlan resmi başarıyla silindi.',
                buttons: 'Tamam'
              }).then(() => this.setState({isLoading: true}, () => {this.getAuctionVehicleInfoForFile();this.setState({isLoading: false});}));
            }
            break;
            default: {
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              }).then(() => this.setState({isLoading: true}, () => {this.getAuctionVehicleInfoForFile(); this.setState({files: ''});this.setState({isLoading: false});}));
            }
            break;
          }
        }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
      }
    });
  }

  deleteVahicleExpertiseDamagePhotoOnClick(uploadId) {
    this.setState({isLoading: true});
    swal({
      dangerMode: true,
      icon: 'warning',
      title: 'Onayla',
      text: 'Ekspertiz hasar resmini silmek istediğinize emin misiniz?',
      buttons: {confirm: 'Tamam', cancel: 'Vazgeç'}
    }).then(value => {
      if (value) {
        let sessionHash = getCookie('sessionHash');

        const requestOptions = {
          method: 'DELETE',
          headers: {'Authorization': 'Bearer ' + sessionHash},
        };

        fetch(config.restApi + 'auctionVehicleDamagePhotoUpload/tr/' + uploadId, requestOptions)
        .then(response => response.json())
        .then(responseData => {
          switch (responseData.status) {
            case 200: {
              swal({
                dangerMode: true,
                icon: 'success',
                title: 'Tamamlandı',
                text: 'Ekspertiz hasar resmi başarıyla silindi.',
                buttons: 'Tamam'
              }).then(() => this.setState({isLoading: true}, () => {this.getAuctionVehicleInfoForDamageFile();this.setState({isLoading: false});}));
            }
            break;
            default: {
              swal({
                dangerMode: true,
                icon: 'warning',
                title: 'Hay Aksi',
                text: responseData.message,
                buttons: 'Tamam'
              }).then(() => this.setState({isLoading: true}, () => {this.getAuctionVehicleInfoForDamageFile(); this.setState({damageFiles: ''});this.setState({isLoading: false});}));
            }
            break;
          }
        }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
      } else {
        this.setState({ isLoading: false });
      }
    });
  }

  saveAuctionVehiclePhotoOnClick = () => {
    let sessionHash = getCookie('sessionHash');

    const updatedData = { ...this.state.auctionVehicle, photos: this.state.auctionVehiclePhotos };

    const requestOptions = {
      method: 'PUT',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify(updatedData)
    };

    fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          if (this.scrollRef.current) {
            this.scrollRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        }
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  saveAuctionVehicleDamagePhotoOnClick = () => {
    let sessionHash = getCookie('sessionHash');

    const updatedData = { ...this.state.auctionVehicle, damagePhotos: this.state.auctionVehicleDamagePhotos };

    const requestOptions = {
      method: 'PUT',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify(updatedData)
    };

    fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          if (this.scrollRefDamageFile.current) {
            this.scrollRefDamageFile.current.scrollIntoView({ behavior: 'smooth' });
          }
        }
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  saveAuctionVehicleOnClick = () => {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const updatedAuctionVehicle = {
        ...this.state.auctionVehicle,
        photos: this.state.auctionVehiclePhotos,
        damagePhotos: this.state.auctionVehicleDamagePhotos
    };

    const requestOptions = {
      method: 'PUT',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify(updatedAuctionVehicle)
    };

    fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false});
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'Araç bilgileri başarıyla güncellendi.',
            buttons: 'Tamam'
          }).then(() => this.props.navigate('/auctionVehicles'));
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  saveAuctionVehicleTramerOnClick = (newDamageHistory) => {
  let sessionHash = getCookie('sessionHash');
  this.setState({ isLoading: true });

  // Eğer edit modundaysa, ilgili item'i güncelle
  let updatedDamageHistoryList = [...this.state.auctionVehicleDamageHistory];
  const editingIndex = updatedDamageHistoryList.findIndex(
    item => item === this.state.editTramer
  );

  if (editingIndex > -1) {
    updatedDamageHistoryList[editingIndex] = newDamageHistory;
  } else {
    updatedDamageHistoryList.push(newDamageHistory);
  }

  // auctionVehicle içine yeni listeyi yerleştir
  const updatedAuctionVehicle = {
    ...this.state.auctionVehicle,
    damageHistory: updatedDamageHistoryList
  };

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Authorization': 'Bearer ' + sessionHash,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updatedAuctionVehicle)
  };

  fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch (responseData.status) {
        case 200: {
          this.setState({
            isLoading: false,
            auctionVehicleDamageHistory: updatedDamageHistoryList,
            editTramer: null,
            isOpenTramerModal: false
          });
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'Araç bilgileri başarıyla güncellendi.',
            buttons: 'Tamam'
          }).then(() => this.getAuctionVehicleInfo());
          break;
        }
        default: {
          this.setState({ isLoading: false });
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
      }
    })
    .catch(() => {
      this.setState({ isLoading: false });
      swal({
        dangerMode: true,
        icon: 'error',
        title: 'Bağlantı Hatası',
        text: 'Lütfen internet bağlantınızı kontrol ediniz.',
        buttons: 'Tamam'
      });
    });
  }

  deleteAuctionVehicleTramer = (damageHistoryToDelete) => {
    this.setState({ isLoading: true });
    swal({
      dangerMode: true,
      icon: 'warning',
      title: 'Onayla',
      text: 'Tramer kaydını silmek istediğinize emin misiniz?',
      buttons: {confirm: 'Tamam', cancel: 'Vazgeç'}
    }).then(value => {
      if (value) {
        let sessionHash = getCookie('sessionHash');

        // Seçili tramer kaydını sil (eşleşen amount, date ve comment ile)
        const updatedDamageHistoryList = this.state.auctionVehicleDamageHistory.filter(item =>
          !(item.queryDate === damageHistoryToDelete.queryDate &&
            item.amount === damageHistoryToDelete.amount &&
            item.date === damageHistoryToDelete.date &&
            item.comment === damageHistoryToDelete.comment)
        );

        const updatedAuctionVehicle = {
          ...this.state.auctionVehicle,
          damageHistory: updatedDamageHistoryList
        };

        const requestOptions = {
          method: 'PUT',
          headers: {
            'Authorization': 'Bearer ' + sessionHash,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updatedAuctionVehicle)
        };

        fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions)
          .then(response => response.json())
          .then(responseData => {
            switch (responseData.status) {
              case 200:
                this.setState({
                  isLoading: false,
                  auctionVehicleDamageHistory: updatedDamageHistoryList
                });
                swal({
                  dangerMode: true,
                  icon: 'success',
                  title: 'Silindi',
                  text: 'Tramer kaydı başarıyla silindi.',
                  buttons: 'Tamam'
                });
                break;

              default:
                this.setState({ isLoading: false });
                swal({
                  dangerMode: true,
                  icon: 'warning',
                  title: 'Hay Aksi',
                  text: responseData.message,
                  buttons: 'Tamam'
                });
            }
          })
          .catch(() => {
            this.setState({ isLoading: false });
            swal({
              dangerMode: true,
              icon: 'error',
              title: 'Bağlantı Hatası',
              text: 'Lütfen internet bağlantınızı kontrol ediniz.',
              buttons: 'Tamam'
            });
          });
      } else {
        this.setState({ isLoading: false });
      }
    });
  };

  getVehicleEquipmentInfo(id) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'vehicleEquipmentDetails/tr/' + id + '?limit=1000', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({vehicleEquipmentInfo: responseData.vehicleEquipmentInfo});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

	handleStatusChange = (value) => {
		this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, soldStatus: value}}));
  };

  handleKeyChange = (value) => {
		this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, hasDublicateKeys: value}}}));
  };

  selectedBrandOnChange = (selectedBrand) => {
    const vehicleBrandId = selectedBrand ? selectedBrand.value : '';
    if (vehicleBrandId) {
      this.getModels(vehicleBrandId);
    } else {
			this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleBrandId: '', year: '', vehicleModelId: '', vehicleEquipmentId: '' }, vehicleModels: [], vehicleModelYears: [], vehicleEquipments: []}));
      return;
    }

		this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleBrandId: vehicleBrandId, year: '', vehicleModelId: '', vehicleEquipmentId: '' }, vehicleModelYears: [], vehicleEquipments: []}));
  };
  
  selectedModelOnChange = (selectedModel) => {
    const vehicleModelId = selectedModel ? selectedModel.value : '';

    if (vehicleModelId) {
      this.getYears(vehicleModelId);
    } else {
			this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleModelId: '', year: '', vehicleEquipmentId: '' }, vehicleModelYears: [], vehicleEquipments: []}));
      return;
    }

		this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleModelId: vehicleModelId, year: '', vehicleEquipmentId: '' }, vehicleModelYears: [], vehicleEquipments: []}));
  };

  selectedYearOnChange = (selectedYear) => {

    const year = selectedYear ? selectedYear.search : ''

    if (year) {
      this.getVariants(this.state.auctionVehicle.vehicleModelId, year);
    } else {
      this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, year: '', vehicleEquipmentId: '' }, vehicleEquipments: []}));
      return;
    }

    this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, year: parseInt(year), vehicleEquipmentId: '' }}));
  }

  selectedVariantOnChange = (selectedVariant) => {
    const vehicleEquipmentId = selectedVariant ? selectedVariant.value : '';
    if (vehicleEquipmentId) {
      this.getVehicleEquipmentInfo(vehicleEquipmentId);
    } else {
      this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleEquipmentId: vehicleEquipmentId }}));
      return;
    }
		this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, vehicleEquipmentId: vehicleEquipmentId }}));
  };

  selectedColorOnChange = (selectedColor) => {
    const colorName = selectedColor ? selectedColor.search : ''
    this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, color: colorName}}}))
  }

  /* selectedYearOnChange = (selectedColor) => {
    const year = selectedColor ? selectedColor.search : ''
    this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, year: parseInt(year)}}))
  } */

  selectedRegistrationTypeOnChange = (selectedColor) => {
    const registrationTypes = selectedColor ? selectedColor.search : ''
    this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, registrationType: registrationTypes}}}))
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMove(this.state.auctionVehiclePhotos, oldIndex, newIndex);
    this.setState({ auctionVehiclePhotos: newOrder }, () => {
      this.saveAuctionVehiclePhotoOnClick(); // Fotoğraf sırası değişince API çağrısı
    });
  };

  onSortEndDamageFile = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMove(this.state.auctionVehicleDamagePhotos, oldIndex, newIndex);
    this.setState({ auctionVehicleDamagePhotos: newOrder }, () => {
      this.saveAuctionVehicleDamagePhotoOnClick(); // Fotoğraf sırası değişince API çağrısı
    });
  };

  handleEdit = (photoId, photoPath) => {
    this.setState({isOpenRotationVehicleModal: true, photoId: photoId, photoPath: photoPath})
  }

  handleDamageFotoEdit = (photoId, photoPath) => {
    this.setState({isOpenRotationVehicleDamageFotoModal: true, photoId: photoId, photoPath: photoPath})
  }

  handleDamageFotoNameEdit = (photoId, damageName, photoPath) => {
    this.setState({isOpenVehicleDamageFotoNameModal: true, photoId: photoId, damageName: damageName, photoPath: photoPath})
  }

  onRotationCompleted = () => {
    this.setState({isLoading: true}, () => {this.getAuctionVehicleInfoForFile(); this.setState({files: ''});this.setState({isLoading: false});});
    this.setState({isOpenRotationVehicleModal: false})
  }

  onRotationDamagePhotoCompleted = () => {
    this.setState({isLoading: true}, () => {this.getAuctionVehicleInfoForDamageFile(); this.setState({damageFiles: ''});this.setState({isLoading: false});});
    this.setState({isOpenRotationVehicleDamageFotoModal: false})
  }

  handleChange = (event) => {
    const input = event.target;
    const value = input.value;
    const selectionStart = input.selectionStart;
    const selectionEnd = input.selectionEnd;

    const upperCaseValue = value.toUpperCase();
    this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, title: upperCaseValue }
    }), () => {
      if (this.inputRef.current) {
        this.inputRef.current.setSelectionRange(selectionStart, selectionEnd);
      }
    });
  }

  render() {

		const selectedBrandsOptions = [
      {value: '', label: 'Seçiniz' }, ...this.state.vehicleBrands.map((brandInfo) => ({
        value: brandInfo.id,
        label: `${brandInfo.name}`,
        search: brandInfo.name
      }))
    ];

    const selectedModelsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleModels.map((modelInfo) => ({
        value: modelInfo.id,
        label: `${modelInfo.name}`,
        search: modelInfo.name
      }))
    ];

    const selectedVariantsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleEquipments.map((variantInfo) => ({
        value: variantInfo.id,
        label: `${variantInfo.name}`,
        search: variantInfo.name
      }))
    ];

    const selectedColorsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.colors.map((colorInfo) => ({
        value: colorInfo.id,
        label: `${colorInfo.name}`,
        search: colorInfo.name
      }))
    ];

    const selectedYearsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.vehicleModelYears.map((yearInfo) => ({
        value: yearInfo.year,
        label: `${yearInfo.year}`,
        search: yearInfo.year
      }))
    ];

    const selectedRegistrationTypeOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.registrationTypes.map((registrationTypeInfo) => ({
        value: registrationTypeInfo.id,
        label: `${registrationTypeInfo.name}`,
        search: registrationTypeInfo.name
      }))
    ];

    const SortableItem = SortableElement(({ value }) => <div style={{ position: "relative"}}>{value}</div>);
    
    const SortableListxs = SortableContainer(({ items }) => (
      <div className='row pl-3'>
        {items.map((photo, index) => (
          <SortableItem key={`item-${index}`} axis={"xy"} index={index} value={
            <div className="mr-2" style={{ position: "relative", display: "inline-block", border:"1px solid lightgray", backgroundColor: "#F5F5F5" }}>
              <img className="col-12 p-0" style={{height: 120, objectFit:"contain", overflow: "visible",  display: "block"}} src={`https://file.satisgaranti.com/${photo.path}`}/>
              <img style={{position: "absolute", top: 0, left: 0}} src={items[0].path === photo.path  ? Images.showCase : ''}/>
              <button className="btn btn-default btn-circle" title='Sil' onClick={() => this.deleteVahiclePhotoOnClick(photo.id)} style={{ position: "absolute", top: 0, right: 0}}><i className="fa fa-close" style={{pointerEvents: 'none', color:"black"}}></i></button>
              <button className="btn btn-default btn-circle" onClick={() => this.handleEdit(photo.id, photo.path)} style={{ position: "absolute", bottom: 0, right: 0}}><i className="fa fa-pencil" style={{pointerEvents: 'none', color:"black"}}></i></button>
            </div>
          }
          />
        ))}
      </div>
    ));

    const ExpertiseDamageSortableListxs = SortableContainer(({ items }) => (
      <div className='row pl-3'>
        {items.map((photo, index) => (
          <SortableItem key={`item-${index}`} axis={"xy"} index={index} value={
            <div className="mr-2" style={{ position: "relative", display: "inline-block", border:"1px solid lightgray", backgroundColor: "#F5F5F5" }}>
              <img className="col-12 p-0" style={{height: 120, objectFit:"contain", overflow: "visible",  display: "block"}} src={`https://file.satisgaranti.com/${photo.path}`}/>
              <img style={{position: "absolute", top: 0, left: 0}} src={items[0].path === photo.path  ? Images.showCase : ''}/>
              <button className="btn btn-default btn-circle" title='Sil' onClick={() => this.deleteVahicleExpertiseDamagePhotoOnClick(photo.id)} style={{ position: "absolute", top: 0, right: 0}}><i className="fa fa-close" style={{pointerEvents: 'none', color:"black"}}></i></button>
              <button className="btn btn-default btn-circle" onClick={() => this.handleDamageFotoNameEdit(photo.id, photo.name, photo.path)} style={{ position: "absolute", bottom: 0, left: 0}}><i className="fa fa-crosshairs" style={{pointerEvents: 'none', color:"black"}}></i></button>
              <button className="btn btn-default btn-circle" onClick={() => this.handleDamageFotoEdit(photo.id, photo.path)} style={{ position: "absolute", bottom: 0, right: 0}}><i className="fa fa-pencil" style={{pointerEvents: 'none', color:"black"}}></i></button>
            </div>
          }
          />
        ))}
      </div>
    ));

    return this.state.isLoading ?
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
      :
      this.state.uploadLoading ?
      <div>
        <div className="d-flex justify-content-center"><strong>Dosyalar yüklenene kadar lütfen sayfada bekleyiniz!</strong></div>
        <div className="progress">
          <div className="progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
      </div>
      :
      <div className="row custom-container">
        <div className="col">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between text-darkblue pr-2">
              <h4 className="text-darkblue">Araç Düzenle</h4>
              <div className="d-flex">
								<button className="btn bg-orange text-white mr-1" onClick={this.saveAuctionVehicleOnClick} title="Kaydet"><i className="fa fa-save"></i></button>
								<button className="btn border btn-darkblue text-white" title="Geri" onClick={() => this.props.navigate(-1)}> <i className="fa fa-reply"></i></button>
							</div>
            </div>
            <div className="row">
              <div className="col">
                <div className="ibox">
                  <div className="ibox-content text-darkblue">
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="col-md-6">
                            <h5><strong>Marka<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              onChange={this.selectedBrandOnChange}
                              options={selectedBrandsOptions}
                              isClearable={true}
                              defaultValue={selectedBrandsOptions.find((brand) => brand.value === this.state.auctionVehicle.vehicleBrandId) || selectedBrandsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedBrandsOptions.find((brand) => brand.value === this.state.auctionVehicle.vehicleBrandId)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Model<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              isDisabled={this.state.vehicleModels.length === 0}
                              onChange={this.selectedModelOnChange}
                              options={selectedModelsOptions}
                              isClearable={true}
                              defaultValue={selectedModelsOptions.find((model) => model.value === this.state.auctionVehicle.vehicleModelId) || selectedModelsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedModelsOptions.find((model) => model.value === this.state.auctionVehicle.vehicleModelId)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Araç Yılı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              isDisabled={this.state.vehicleModelYears.length === 0}
                              onChange={this.selectedYearOnChange}
                              options={selectedYearsOptions}
                              isClearable={true}
                              defaultValue={selectedYearsOptions.find((year) => year.value == this.state.auctionVehicle.year) || selectedYearsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedYearsOptions.find((year) => year.value == this.state.auctionVehicle.year)}
                              /* filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              } */
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Donanım<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              isDisabled={this.state.vehicleEquipments.length === 0}
                              onChange={this.selectedVariantOnChange}
                              options={selectedVariantsOptions}
                              isClearable={true}
                              defaultValue={selectedVariantsOptions.find((variant) => variant.value === this.state.auctionVehicle.vehicleEquipmentId) || selectedVariantsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedVariantsOptions.find((variant) => variant.value === this.state.auctionVehicle.vehicleEquipmentId)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          {
                            this.state.vehicleEquipmentInfo &&
                            this.state.vehicleEquipmentInfo.details &&
                            Array.isArray(this.state.vehicleEquipmentInfo.details.specs) &&
                            this.state.vehicleEquipmentInfo.details.specs.length > 0 ? (
                              <div className="col-12">
                                <div>
                                  <div className="row">
                                    {this.state.vehicleEquipmentInfo.details.specs.map((group, groupIndex) => (
                                      <div className="col-12 my-3" key={`spec-group-${groupIndex}`}>
                                        <h4 className="d-flex text-properties font-bold text-orange px-2">{group.group}</h4>
                                        <div className="row">
                                          {group.items.map((item, itemIndex) => (
                                            <div className="col-md-6 mb-2" key={`spec-item-${itemIndex}`}>
                                              <div className="d-flex align-items-center flex-row text-properties">
                                                <span className="d-flex properties-width text-left p-2">
                                                  <i className="fa fa-check text-green d-flex align-items-center mr-1"></i>
                                                  {item.label}: {item.value}
                                                </span>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="text-center m-3">Donanım Özelliği Bulunamadı.</div>
                            )
                          }
                          <div className="col-12">
                            <h5><strong>Başlık<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-control-sm form-input mb-1" ref={this.inputRef} onChange={this.handleChange} onKeyDown={this.handleKeyPress} placeholder="Başlık" type="text" value={this.state.auctionVehicle.title || ''} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>KM<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input
                              className="form-control form-input mb-1"
                              onChange={event => {
                                const value = event.target.value.replace(/[^0-9]/g, ""); // sadece rakam
                                const parsedValue = parseInt(value || 0, 10);

                                this.setState(prevState => ({
                                  auctionVehicle: {
                                    ...prevState.auctionVehicle,
                                    details: {
                                      ...prevState.auctionVehicle.details,
                                      km: isNaN(parsedValue) ? "" : parsedValue // state'e sade sayı kaydet
                                    }
                                  }
                                }));
                              }}
                              onKeyDown={this.handleKeyPress}
                              placeholder="KM"
                              type="text"
                              value={
                                this.state.auctionVehicle?.details?.km
                                  ? new Intl.NumberFormat("tr-TR").format(this.state.auctionVehicle.details.km) // formatlı gösterim
                                  : ""
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Plaka<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => { const plateNumber = event.target.value.replace(/\s/g, '').toUpperCase(); this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, plateNumber }}}));}} onKeyDown={this.handleKeyPress} placeholder="Plaka" type="text" value={this.state.auctionVehicle.details?.plateNumber || ''} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Araç Rengi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              onChange={this.selectedColorOnChange}
                              options={selectedColorsOptions}
                              isClearable={true}
                              defaultValue={selectedColorsOptions.find((color) => color.search === this.state.auctionVehicle.details?.color) || selectedColorsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedColorsOptions.find((color) => color.search === this.state.auctionVehicle.details?.color)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Yakıt Tipi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Yakıt Tipi" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, fuelType: event.target.value}}}));}} value={this.state.auctionVehicle?.details?.fuelType}>
                              <option value="" disabled>Yakıt Tipi</option>
                              {this.state.fuelTypes.map((fuelType, index) =>
                                <option key={index} value={fuelType.type}>{fuelType.type}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Vites Tipi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Vites Tipi" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, transmissionType: event.target.value}}}));}} value={this.state.auctionVehicle?.details?.transmissionType}>
                              <option value="" disabled>Vites Tipi</option>
                              {this.state.transmissions.map((transmission, index) =>
                                <option key={index} value={transmission.type}>{transmission.type}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Çekiş Tipi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Çekiş Tipi" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, tractionType: event.target.value}}}));}} value={this.state.auctionVehicle?.details?.tractionType}>
                              <option value="" disabled>Çekiş Tipi</option>
                              {this.state.tractions.map((traction, index) =>
                                <option key={index} value={traction.type}>{traction.type}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Motor Hacmi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, engineCapacity: event.target.value}}}));}} onKeyDown={this.handleKeyPress} placeholder="Motor Hacmi" type="text" value={this.state.auctionVehicle?.details?.engineCapacity || ''} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Motor No<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, engineNumber: event.target.value.toUpperCase()}}}));}} onKeyDown={this.handleKeyPress} placeholder="Motor No" type="text" value={this.state.auctionVehicle?.details?.engineNumber || ''} />
                          </div>
                          <div className="col-md-6 mt-2">
                            <h5><strong>Şasi No<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, chassisNumber: event.target.value.toUpperCase()}}}));}} onKeyDown={this.handleKeyPress} placeholder="Şasi No" type="text" value={this.state.auctionVehicle?.details?.chassisNumber} />
                          </div>
                          <div className="col-md-6 mt-2">
                            <h5><strong>Ruhsat Cinsi (Otomobil, Kamyon vb.)<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              onChange={this.selectedRegistrationTypeOnChange}
                              options={selectedRegistrationTypeOptions}
                              isClearable={true}
                              defaultValue={selectedRegistrationTypeOptions.find((registrationType) => registrationType.search === this.state.auctionVehicle?.details?.registrationType) || selectedRegistrationTypeOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedRegistrationTypeOptions.find((registrationType) => registrationType.search === this.state.auctionVehicle?.details?.registrationType)}
                              filterOption={(option, searchText) =>
                                option.data.search &&
                                option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Ruhsat Tipi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, registrationCode: event.target.value.toUpperCase()}}}));}} onKeyDown={this.handleKeyPress} placeholder="Ruhsat Tipi" type="text" value={this.state.auctionVehicle?.details?.registrationCode || ''} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Yetki Belge No<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, details: { ...prevState.auctionVehicle.details, authorizationCertificateNumber: event.target.value}}}));}} onKeyDown={this.handleKeyPress} placeholder="Yetki Belge No" type="text" value={this.state.auctionVehicle?.details?.authorizationCertificateNumber || ''} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Açıklama<strong className="text-danger ml-1">*</strong></strong></h5>
                            <textarea className="form-control form-control-sm form-input mb-1" onChange={event => this.setState(prevState => ({auctionVehicle: {...prevState.auctionVehicle, comment: event.target.value}}))} onKeyDown={this.handleKeyPress} placeholder="Açıklama" style={{minHeight:70}} vtype="text" value={this.state.auctionVehicle?.comment} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Satış Durumu<strong className="text-danger ml-1">*</strong></strong></h5>
                            <div className="form-check">
                              <input className="form-check-input" checked={this.state.auctionVehicle.soldStatus === 1} id="radioDefault1" name="radioDefault" onChange={() => this.handleStatusChange(1)} type="radio" />
                              <label className="form-check-label" htmlFor="radioDefault1">Satıldı</label>
                            </div>
                            <div className="form-check">
                              <input className="form-check-input" checked={this.state.auctionVehicle.soldStatus === 0} id="radioDefault2" name="radioDefault" onChange={() => this.handleStatusChange(0)} type="radio" />
                              <label className="form-check-label" htmlFor="radioDefault2">Satılmadı</label>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Yedek Anahtar Var Mı?<strong className="text-danger ml-1">*</strong></strong></h5>
                            <div className="form-check">
                              <input className="form-check-input" checked={this.state.auctionVehicle?.details?.hasDublicateKeys === true} id="hasDublicateKeys1" name="hasDublicateKeys" onChange={() => this.handleKeyChange(true)} type="radio" />
                              <label className="form-check-label" htmlFor="hasDublicateKeys1">Evet</label>
                            </div>
                            <div className="form-check">
                              <input className="form-check-input" checked={this.state.auctionVehicle?.details?.hasDublicateKeys === false} id="hasDublicateKeys2" name="hasDublicateKeys" onChange={() => this.handleKeyChange(false)} type="radio" />
                              <label className="form-check-label" htmlFor="hasDublicateKeys2">Hayır</label>
                            </div>
                          </div>
                          <div className="col-12">
                            <h5 className="text-darkblue mt-2" ref={this.scrollRef}><strong>Fotoğraf</strong></h5>
                            <div className="ibox-content">
                              <SortableListxs axis={"xy"} items={this.state.auctionVehiclePhotos} onSortEnd={this.onSortEnd}/>
                              <form className="d-flex align-items-center justify-content-center dropzone">
                                <div className="fallback">
                                  <input accept=".jpg, .jpeg, .png, .pdf, .JPG, .JPEG, .PNG, .PDF" multiple name="file" onChange={(e) => {this.setState({ files: e.target.files }, () => {this.saveFileUpload();});}} style={{paddingLeft:"15%"}} type="file"/>
                                </div>
                              </form>
                              <div className="d-flex justify-content-end">{this.state.auctionVehiclePhotos.length} dosya yüklendi</div>
                            </div>
                          </div>
                        </div>
                        <h4 className="text-darkblue mt-2">Ekspertiz</h4>
                        <hr />
                        <div className="row">
                          <div className="col-md-6">
                            <h5><strong>Ön Tampon<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Ön Tampon" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, frontBumper: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.frontBumper || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Ön Sol Çamurluk<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Ön Sol Çamurluk" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, frontLeftMudguard: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.frontLeftMudguard || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Ön Kaput<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Ön Kaput" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, frontHood: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.frontHood || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Ön Sol Kapı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Ön Sol Kapı" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, frontLeftDoor: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.frontLeftDoor || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Tavan<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Tavan" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, roof: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.roof || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Arka Sol Kapı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Arka Sol Kapı" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, rearLeftDoor: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.rearLeftDoor || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Ön Sağ Çamurluk<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Ön Sağ Çamurluk" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, frontRightMudguard: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.frontRightMudguard || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Arka Sol Çamurluk<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Arka Sol Çamurluk" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, rearLeftMudguard: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.rearLeftMudguard || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Ön Sağ Kapı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Ön Sağ Kapı" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, frontRightDoor: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.frontRightDoor || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Arka Kaput<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Arka Kaput" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, rearHood: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.rearHood || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Arka Sağ Kapı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Arka Sağ Kapı" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, rearRightDoor: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.rearRightDoor || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Arka Tampon<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Arka Tampon" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, rearBumper: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.rearBumper || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Arka Sağ Çamurluk<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="Arka Sağ Çamurluk" onChange={event => {this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, parts: { ...prevState.auctionVehicle.appraisalResult.parts, rearRightMudguard: event.target.value }}}}));}} value={this.state.auctionVehicle?.appraisalResult?.parts?.rearRightMudguard || 'original'}>
                              {this.state.partsStatus.map((part, index) =>
                                <option key={index} value={part.id}>{part.name}</option>
                              )}
                            </select>
                          </div>
                          <div className="col-12">
                            <h5><strong>Ekspertiz Açıklaması<strong className="text-danger ml-1">*</strong></strong></h5>
                            <textarea className="form-control form-input mb-1" onChange={event => { this.setState(prevState => ({ auctionVehicle: { ...prevState.auctionVehicle, appraisalResult: { ...prevState.auctionVehicle.appraisalResult, comment: event.target.value}}}));}} placeholder="Açıklama" type="email" value={this.state.auctionVehicle?.appraisalResult?.comment || ''} />
                          </div>
                          <div className="col-12">
                            <h5 className="text-darkblue mt-2" ref={this.scrollRefDamageFile}><strong>Hasar Fotoğrafları</strong></h5>
                            <div className="ibox-content">
                              <ExpertiseDamageSortableListxs axis={"xy"} items={this.state.auctionVehicleDamagePhotos} onSortEnd={this.onSortEndDamageFile}/>
                              <form className="d-flex align-items-center justify-content-center dropzone">
                                <div className="fallback">
                                  <input accept=".jpg, .jpeg, .png, .pdf, .JPG, .JPEG, .PNG, .PDF" multiple name="file" onChange={(e) => {this.setState({ damageFiles: e.target.files }, () => {this.saveDamageFileUpload();});}} style={{paddingLeft:"15%"}} type="file"/>
                                </div>
                              </form>
                              <div className="d-flex justify-content-end">{this.state.auctionVehicleDamagePhotos.length} dosya yüklendi</div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col mt-3">
                            <div className="d-flex justify-content-between">
                              <h4 className="text-darkblue">Tramer</h4>
                              <button className="btn btn-orange" onClick={() => this.setState({editTramer: null, isOpenTramerModal: true})} title="Tramer Ekle"><i className="fa fa-plus"></i></button>
                            </div>
                            <div className="hr-line-dashed"></div>
                            <div className="overflow-auto">
                              <table className="table table-striped table-bordered">
                                <thead>
                                  <tr className="text-center text-darkblue">
                                    <th>Sorgu Tarihi</th>
                                    <th>Tramer Ücreti</th>
                                    <th>Tramer Tarihi</th>
                                    <th>Açıklama</th>
                                    <th>İşlem</th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  {this.state.auctionVehicleDamageHistory.map((damageHistory, index) =>
                                    <tr key={index}>
                                      <td className="align-middle">{damageHistory.queryDate ? isoToDate(damageHistory.queryDate) : '-'}</td>
                                      <td className="align-middle">{priceFormat(damageHistory.amount)} ₺</td>
                                      <td className="align-middle">{isoToDate(damageHistory.date)}</td>
                                      <td className="align-middle">{damageHistory.comment}</td>
                                      <td className="align-middle" style={{minWidth:98.5}}>
                                        <button className="btn btn-orange m-1" onClick={() => {this.setState({isLoading: true, editTramer: damageHistory, isOpenTramerModal: true }, () => {this.setState({ isLoading: false });});}} title="Düzenle"><i className="fa fa-pencil"></i></button>
                                        <button className="btn btn-darkblue" onClick={() => this.deleteAuctionVehicleTramer(damageHistory)} title="Sil"><i className="fa fa-trash"></i></button>
                                      </td>
                                    </tr>
                                  )}
                                  {this.state.auctionVehicleDamageHistory.length === 0 ?
                                    <tr>
                                      <td className="align-middle p-3" colSpan="5">Tramer Kaydı Bulunamadı !</td>
                                    </tr>
                                  : null}
                                </tbody>
                              </table>
                              <TramerModal isOpen={this.state.isOpenTramerModal} modalTitle="Tramer Ekle" modalDescription="Tramer bilgisi eklemek için aşağıdaki alanları doldurunuz !" onRequestClose={() => this.setState({editTramer: null, isOpenTramerModal: false})} saveOnClick={e => this.saveAuctionVehicleTramerOnClick(e)} />
                              {this.state.editTramer ?
                                <TramerModal defaultValue={this.state.editTramer} isOpen={this.state.isOpenTramerModal} modalTitle="Tramer Düzenle" modalDescription="Tramer bilgisini düzenlemek için aşağıdaki alanları doldurunuz !" onRequestClose={() => this.setState({editTramer: null, isOpenTramerModal: false})} saveOnClick={e => this.saveAuctionVehicleTramerOnClick(e)} />
                              : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-row text-right mt-2">
                      <button className="btn bg-orange text-white" onClick={this.saveAuctionVehicleOnClick}><i className="fa fa-save"></i> Kaydet</button>
                    </div>
                    <VehicleRotationModal photoPath={this.state.photoPath} photoId={this.state.photoId} isOpen={this.state.isOpenRotationVehicleModal} modalTitle="Resim Döndürme" modalDescription=" " onRotationCompleted={this.onRotationCompleted} onRequestClose={() => this.setState({isOpenRotationVehicleModal: false})} />
                    <VehicleRotationDamagePhotoModal photoPath={this.state.photoPath} photoId={this.state.photoId} isOpen={this.state.isOpenRotationVehicleDamageFotoModal} modalTitle="Resim Döndürme" modalDescription=" " onRotationDamagePhotoCompleted={this.onRotationDamagePhotoCompleted} onRequestClose={() => this.setState({isOpenRotationVehicleDamageFotoModal: false})} />
                    <VehicleDamagePhotoNameModal photoPath={this.state.photoPath} photoId={this.state.photoId} damageName={this.state.damageName} isOpen={this.state.isOpenVehicleDamageFotoNameModal} modalTitle="Hasar Bölgesi" modalDescription=" " onRotationDamagePhotoCompleted={this.onRotationDamagePhotoCompleted} onRequestClose={() => this.setState({isOpenVehicleDamageFotoNameModal: false})} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  }
}

export default function AuctionVehicleEdit(props) {
  return (
    <AuctionVehicleEditModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionVehicleEditModule>
  );
}
